/* 注册 页面滚动条 事件 */
import { throttle } from 'throttle-debounce'
import {on, off} from '@zjy/zjy-ui/lib/utils/dom'
function EventEmiter () {
  // 维护一个对象
  this._events = []
  return this
}

EventEmiter.prototype.scroll = function (cb) {
  this._events.push(cb)
  return this
}

EventEmiter.prototype.off = function (cb) {
  let temp = []
  for (let i = 0; i < this._events.length; i++) {
    if (this._events[i] !== cb) {
      temp.push(this._events[i])
    }
  }
  this._events = temp
  return this
}

EventEmiter.prototype.emit = function () {
  if (this._events.length) {
    for (let i = 0; i < this._events.length; i++) {
      this._events[i]()
    }
  }
  return this
}

export default {
  data () {
    return {
      scrollHandle: new EventEmiter()
    }
  },
  beforeDestroy () {
    off(document, 'scroll', this._scrollEventEmiter)
    this.resizeHandle = null
  },
  mounted () {
    on(document, 'scroll', this._scrollEventEmiter)
  },
  methods: {
    _scrollEventEmiter () {
      return throttle(100, this.scrollHandle.emit.bind(this.scrollHandle))()
    }
  }
}
